import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./style.scss";
import { useMediaQuery } from "react-responsive";

const Index = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <section className="frontpage-introduction-section">
      <div className="inner-frontpage-introduction-container">
        <div className="content-container">
          <div className="details-container">
            <h1
              data-aos="fade-up"
              data-aos-offset={isMobile ? "0" : "200"}
              data-aos-delay="50"
              data-aos-duration="1500"
              className="introduction-title"
            >
              Et <span className="gradient">salgsverktøy og CRM</span> som
              hjelper deg med å finne nye kunder - mye enklere.
            </h1>
            <p
              data-aos="fade-up"
              data-aos-offset={isMobile ? "0" : "200"}
              data-aos-delay="250"
              data-aos-duration="1700"
              className="introduction-description"
            >
              Leadfind er et enkelt og brukervennlig CRM og salgsverktøy for
              virksomheter som jobber både B2B og B2C. Få bedre oversikt over
              kunder, prestasjoner, prosesser og tilgang på blant annet
              listegenerering som gir deg mulighet til å nå ut til absolutt alle
              registrerte foretak i hele Norge, bare ved et par klikk.
            </p>
            <div className="button-container">
              <Link to="/registrer">
                <button
                  data-aos="fade-up"
                  data-aos-delay="450"
                  data-aos-offset={isMobile ? "0" : "200"}
                  data-aos-duration="1900"
                  className="get-started-button"
                >
                  Få 14 dager gratis prøveperiode
                </button>
              </Link>
              <small
                data-aos="fade-up"
                data-aos-delay="650"
                data-aos-offset={isMobile ? "0" : "200"}
                data-aos-duration="2100"
              >
                Kun 399kr eks moms pr måned/pr brukertilgang etter endt
                prøveperiode, med mulighet til å kansellere når som helst før.
              </small>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Index;
